var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Button',{attrs:{"id":"button-copy","view":"secondary","isDisabled":_vm.isLoading || _vm.isComplete,"icon":(_vm.isLoading || _vm.isComplete) ? undefined : 'icon-copy_outline'},on:{"click":_vm.copy}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }